<template>
  <div class="trustpilot-slide-default">
    <img
      :alt="`Star `+props.review.stars"
      width="108"
      height="20"
      loading="lazy"
      class="trustpilot-slide-default__rate"
      :src="getImgUrl(props.review.stars)"
    />
    <div class="trustpilot-slide-default__title">
      <template v-if="props.review.reviewUrl">
        <a :href="props.review.reviewUrl" ref="noopener" target="_blank">
          {{ props.review.title }}
        </a>
      </template>
      <template v-else>
        {{ props.review.title }}
      </template>
    </div>
    <div class="trustpilot-slide-default__text">
      {{ props.review.text }}
    </div>
    <div class="trustpilot-slide-default__footer">
      <div class="trustpilot-slide-default__consumer">
        {{ props.review.consumer }}
      </div>
      <div class="trustpilot-slide-default__date">{{ props.review.createdAtString }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ReviewDefault } from './types';

const props = defineProps<{
  review: ReviewDefault
}>();

function getImgUrl(rate: string) {
  return new URL(`../../../assets/images/trustpilot/default/stars-${rate}.svg`, import.meta.url).href;
}
</script>

<style scoped lang="scss">
@use '@kanoAssets/styles/breakpoints.scss';

.trustpilot-slide-default {
  &__rate {
    width: 108px;
    margin-bottom: 16px;
  }

  &__title {
    font-family: Inter Tight, Inter Tight fallback, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;

    @include breakpoints.desktop {
      font-size: 18px;
      line-height: 26px;
    }

    a {
      color: var(--color-base);
      text-decoration: none;
    }
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;

    @include breakpoints.desktop {
      font-size: 18px;
      line-height: 26px;
    }
  }

  &__consumer, &__date {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-base-48);
  }

  &__consumer {
    overflow: hidden;
    text-emphasis: ellipsis;
  }

  &__date {
    min-width: max-content;
  }

  &__footer {
    margin-top: auto;
    padding-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
  }
}
</style>